import React, { Component, Fragment } from "react";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import { Button } from "@material-ui/core";

class Bookkeeping extends Component {
  render() {
    return (
      <div className="center width100">
        <Card>
          <CardContent>
            <h4 className="yellow-color">הנהלת חשבונות</h4>
            <div className="mb-20">
              <div className="inline-block ml-20">
                <TextField
                  id="bookKeepingName"
                  onChange={this.props.handleChange}
                  value={this.props.bookKeepingName}
                  disabled={this.props.isNotEditMode}
                  label="שם מלא"
                />
              </div>
              <TextField
                id="bookKeepingEmail"
                onChange={this.props.handleChange}
                value={this.props.bookKeepingEmail}
                disabled={this.props.isNotEditMode}
                label="אימייל"
              />
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default Bookkeeping;
